<!--
Auto-generated by: https://github.com/threlte/threlte/tree/main/packages/gltf
Command: npx @threlte/gltf@2.0.3 /Users/nrumak/Development/square-dt-labs/static/nrumak/X2_modified.glb -u -t -P
-->

<script module lang="ts">
  import { Group, Material, Mesh, MeshStandardMaterial } from 'three';
  import { T, type Props } from '@threlte/core';
  import { useGltf, useSuspense } from '@threlte/extras';
  import type { Snippet } from 'svelte';

  const scale = 4;

  type GLTFResult = {
    nodes: {
      Mesh001: Mesh;
      Mesh001_1: Mesh;
      Mesh001_2: Mesh;
      Mesh001_3: Mesh;
      Mesh001_4: Mesh;
      Mesh001_5: Mesh;
    };
    materials: {
      MI_emit_UESM: MeshStandardMaterial;
    };
  };

  let modelUrl = '';

  const load = () => {
    const suspend = useSuspense();
    return suspend(useGltf<GLTFResult>(modelUrl));
  };

  export const preload = async (url: string) => {
    modelUrl = url;
    try {
      await load();
    } catch (err) {
      return console.error('Failed to load model', err);
    }
  };
</script>

<script lang="ts">
  let {
    fallback,
    error,
    children,
    ref = $bindable(),
    matcaps,
    fallbackMaterial,
    ...props
  }: Props<Group> & {
    ref?: Group;
    matcaps: {
      silver: Material;
      blackFrame: Material;
      x2_screen_front: Material;
      x2_screen_back: Material;
    };
    fallbackMaterial: Material;
    children?: Snippet<[{ ref: Group | undefined }]>;
    fallback?: Snippet;
    error?: Snippet<[{ error: Error }]>;
  } = $props();

  let materials: any = $state(matcaps);

  const gltf = load();

  $effect(() => {
    materials = matcaps ?? {
      silver: fallbackMaterial,
      blackFrame: fallbackMaterial,
      x2_screen_front: fallbackMaterial,
      x2_screen_back: fallbackMaterial,
    };
  });
</script>

<T is={new Group()} bind:ref dispose={false} {...props} {scale}>
  {#await gltf}
    {@render fallback?.()}
  {:then gltf}
    <T.Group rotation={[Math.PI / 2, 0, 0]} scale={0.01}>
      <T.Mesh geometry={gltf.nodes.Mesh001.geometry} material={materials.x2_screen_front} />
      <T.Mesh geometry={gltf.nodes.Mesh001_1.geometry} material={materials.silver} />
      <T.Mesh geometry={gltf.nodes.Mesh001_2.geometry} material={materials.blackFrame} />
      <!-- <T.Mesh geometry={gltf.nodes.Mesh001_3.geometry} material={gltf.materials.MI_emit_UESM} /> -->
      <T.Mesh geometry={gltf.nodes.Mesh001_4.geometry} material={materials.blackFrame} />
      <T.Mesh geometry={gltf.nodes.Mesh001_5.geometry} material={materials.x2_screen_back} />
    </T.Group>
  {:catch err}
    {@render error?.({ error: err })}
  {/await}
  {@render children?.({ ref })}
</T>
